import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'app/services';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class HeaderComponent {

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  @Output()
  readonly menuToggle = new EventEmitter<void>();

  userMenuItems = [{
    text: 'Profile',
    icon: 'user',
    onClick: () => {
      location.href = `${environment.wpUrl}/dashboard`
    }
  },
  {
    text: 'Logout',
    icon: 'runner',
    onClick: () => {
      this.userService.logout();
    }
  }];

  constructor(private router: Router, private userService: UserService) { }

  get userEmail(): string | undefined {
    return this.userService.loggedUser?.user_email;
  }

  toggleMenu() {
    this.menuToggle.emit();
  }

  toggleLogo = () => {
    this.router.navigate(['/']);
  }
}
